import { ArabicEach, findRecursive } from '@/mm/utils.js'

export function washData_productImgText3(walkedNode) {
  const ProNode = findRecursive(walkedNode.list, (item) => item._type === 'button_text_1', 'list')
  const colNode = findRecursive(walkedNode.list, (item) => item._type === 'widgets_rowCol2', 'list')
  if (ProNode) {
    if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
      ProNode.actions[0].config['文字设计'].unshift('self_textInput')
    }
    if (!ProNode.actions.find((item) => item === 'translate')) {
      ProNode.actions.push('translate')
    }
    colNode.isRadiuShow = true
    colNode.actions = ['design', 'hover']
  }

  let ArabicRule = [
    {
      flag: 'product_title_flag',
      dataType: ['design'],
      onlyEnglish: ['title_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    },
    {
      flag: 'product_content_title_flag',
      dataType: ['design'],
      onlyEnglish: ['title_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    },
    {
      flag: 'product_content_flag',
      dataType: ['design'],
      onlyEnglish: ['title_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    },
    {
      flag: 'product_button_flag',
      dataType: ['design'],
      onlyEnglish: ['self_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    }
  ]
  ArabicEach(walkedNode, ArabicRule)
}
